var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNavDesktopHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 3C2.25 2.58579 2.58579 2.25 3 2.25H7.5C7.91421 2.25 8.25 2.58579 8.25 3V7.5C8.25 7.91421 7.91421 8.25 7.5 8.25H3C2.58579 8.25 2.25 7.91421 2.25 7.5V3ZM3.75 3.75V6.75H6.75V3.75H3.75Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 3C9.75 2.58579 10.0858 2.25 10.5 2.25H15C15.4142 2.25 15.75 2.58579 15.75 3V7.5C15.75 7.91421 15.4142 8.25 15 8.25H10.5C10.0858 8.25 9.75 7.91421 9.75 7.5V3ZM11.25 3.75V6.75H14.25V3.75H11.25Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 10.5C9.75 10.0858 10.0858 9.75 10.5 9.75H15C15.4142 9.75 15.75 10.0858 15.75 10.5V15C15.75 15.4142 15.4142 15.75 15 15.75H10.5C10.0858 15.75 9.75 15.4142 9.75 15V10.5ZM11.25 11.25V14.25H14.25V11.25H11.25Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 10.5C2.25 10.0858 2.58579 9.75 3 9.75H7.5C7.91421 9.75 8.25 10.0858 8.25 10.5V15C8.25 15.4142 7.91421 15.75 7.5 15.75H3C2.58579 15.75 2.25 15.4142 2.25 15V10.5ZM3.75 11.25V14.25H6.75V11.25H3.75Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavDesktopHome);
export default __webpack_public_path__ + "static/media/nav-desktop-home.8bd34b6dfecbd9ac065e2e154f3d0723.svg";
export { ForwardRef as ReactComponent };